/**
 * Lightbox dialogs replacing window.confirm / window.alert (site-wide).
 * Loaded via gulp before assets/js/*.js — exposes window.VistaGareUi.
 */
(function () {
    var UI_KEY = 'VistaGareUi';

    function lockScroll(on) {
        try {
            document.documentElement.classList.toggle('vg-kanban-modal-lock', !!on);
        } catch (e) {}
    }

    function ensureConfirmRoot() {
        var existing = document.getElementById('vg-dialog-confirm');
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = 'vg-dialog-confirm';
        wrap.className = 'vg-kanban-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel" role="document">' +
            '  <h2 class="vg-kanban-modal__title" data-title></h2>' +
            '  <p class="vg-kanban-modal__message" data-message></p>' +
            '  <div class="vg-kanban-modal__actions">' +
            '    <button type="button" class="vg-kanban-modal__btn" data-cancel>Annulla</button>' +
            '    <button type="button" class="vg-kanban-modal__btn vg-kanban-modal__btn--danger" data-confirm>OK</button>' +
            '  </div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    function ensureAlertRoot() {
        var existing = document.getElementById('vg-dialog-alert');
        if (existing) return existing;
        var wrap = document.createElement('div');
        wrap.id = 'vg-dialog-alert';
        wrap.className = 'vg-kanban-modal';
        wrap.setAttribute('hidden', 'hidden');
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.innerHTML =
            '<div class="vg-kanban-modal__panel" role="document">' +
            '  <h2 class="vg-kanban-modal__title" data-title></h2>' +
            '  <p class="vg-kanban-modal__message" data-message></p>' +
            '  <div class="vg-kanban-modal__actions">' +
            '    <button type="button" class="vg-kanban-modal__btn vg-kanban-modal__btn--danger" data-ok>OK</button>' +
            '  </div>' +
            '</div>';
        (document.body || document.documentElement).appendChild(wrap);
        return wrap;
    }

    /**
     * @param {{ title?: string, message?: string, cancelText?: string, confirmText?: string, danger?: boolean }} opts
     * @returns {Promise<boolean>}
     */
    function confirm(opts) {
        opts = opts || {};
        var modal = ensureConfirmRoot();
        var titleEl = modal.querySelector('[data-title]');
        var msgEl = modal.querySelector('[data-message]');
        var btnCancel = modal.querySelector('[data-cancel]');
        var btnConfirm = modal.querySelector('[data-confirm]');
        if (titleEl) titleEl.textContent = opts.title || 'Conferma';
        if (msgEl) msgEl.textContent = opts.message || '';
        if (btnCancel) btnCancel.textContent = opts.cancelText || 'Annulla';
        if (btnConfirm) {
            btnConfirm.textContent = opts.confirmText || 'OK';
            btnConfirm.classList.toggle('vg-kanban-modal__btn--danger', !!opts.danger);
        }

        modal.removeAttribute('hidden');
        lockScroll(true);
        var prev = document.activeElement;
        try {
            (btnCancel || btnConfirm).focus();
        } catch (e) {}

        return new Promise(function (resolve) {
            function close(result) {
                cleanup();
                modal.setAttribute('hidden', 'hidden');
                lockScroll(false);
                try {
                    if (prev && prev.focus) prev.focus();
                } catch (e2) {}
                resolve(!!result);
            }
            function onKey(e) {
                if (e.key === 'Escape') close(false);
            }
            function onBackdrop(e) {
                if (e.target === modal) close(false);
            }
            function onCancel() {
                close(false);
            }
            function onConfirm() {
                close(true);
            }
            function cleanup() {
                document.removeEventListener('keydown', onKey);
                modal.removeEventListener('click', onBackdrop);
                if (btnCancel) btnCancel.removeEventListener('click', onCancel);
                if (btnConfirm) btnConfirm.removeEventListener('click', onConfirm);
            }
            document.addEventListener('keydown', onKey);
            modal.addEventListener('click', onBackdrop);
            if (btnCancel) btnCancel.addEventListener('click', onCancel);
            if (btnConfirm) btnConfirm.addEventListener('click', onConfirm);
        });
    }

    /**
     * @param {string} message
     * @param {{ title?: string, okText?: string }} [opts]
     * @returns {Promise<void>}
     */
    function alert(message, opts) {
        opts = opts || {};
        var modal = ensureAlertRoot();
        var titleEl = modal.querySelector('[data-title]');
        var msgEl = modal.querySelector('[data-message]');
        var btnOk = modal.querySelector('[data-ok]');
        if (titleEl) titleEl.textContent = opts.title || 'Avviso';
        if (msgEl) msgEl.textContent = message || '';
        if (btnOk) btnOk.textContent = opts.okText || 'OK';

        modal.removeAttribute('hidden');
        lockScroll(true);
        var prev = document.activeElement;
        try {
            btnOk.focus();
        } catch (e) {}

        return new Promise(function (resolve) {
            function close() {
                cleanup();
                modal.setAttribute('hidden', 'hidden');
                lockScroll(false);
                try {
                    if (prev && prev.focus) prev.focus();
                } catch (e2) {}
                resolve();
            }
            function onKey(e) {
                if (e.key === 'Escape') close();
            }
            function onBackdrop(e) {
                if (e.target === modal) close();
            }
            function cleanup() {
                document.removeEventListener('keydown', onKey);
                modal.removeEventListener('click', onBackdrop);
                if (btnOk) btnOk.removeEventListener('click', close);
            }
            document.addEventListener('keydown', onKey);
            modal.addEventListener('click', onBackdrop);
            if (btnOk) btnOk.addEventListener('click', close);
        });
    }

    window[UI_KEY] = {
        confirm: confirm,
        alert: alert
    };
})();
